module.exports = __webpack_public_path__ + "m4a/spin.m4a?8ac956dd4652b2455688ee5cb3599a45";